import { Deserializable } from '../protocols/deserializable';

export class RemittanceType implements Deserializable {
  public id!: number;
  public name!: string;

  public onDeserialize() {}
}
